var map = {
	"./auction-1.png": "8c7d",
	"./auction-2.png": "8cff",
	"./auction-3.png": "bfcd",
	"./auction-4.png": "989a",
	"./auction-5.png": "0722",
	"./auction-6.png": "4318"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a9a";